const host = `http://admin.waifu-xorikita.ru`
export default host